import React, { useState, useReducer, useEffect } from 'react';
import { useDispatch as useReduxDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import moment from 'moment';
import { toast } from 'react-toastify';
import qs from 'qs';
import isMobile from 'ismobilejs';

import DesktopLayout from './DesktopLayout';
import MobileLayout from './MobileLayout';

import Button from '../../common/Button';

import {
  fetchGetOrdersForOrdersPage,
  fetchGetOrdersStatusesLength,
  fetchConfirmOrder,
  fetchGetOrdersReport,
  fetchCopyOrder,
  fetchTags,
  fetchCancelOrder,
} from '../../../actions/orders';
import { fetchUpdatePackingBatch } from '../../../actions/packing';
import { showModal } from '../../../actions/modal';

import {
  getPaymentBagdeStyle,
  saveBase64AsPdf,
  statusOptions,
  getCurrencySymbol,
} from '../../../helpers';
import { formatPhone } from '../../../helpers/phoneFormatter';

import { ORDERS_COUNT_ON_PAGE, ORDERS_PAGE_TABS } from '../../../config';
import Adaptive from '../../common/Adaptive';

const ActionsButtonWrapper = styled('div')`
  .dropdown-menu.show {
    top: auto !important;
    bottom: 100% !important;
  }
  .dropdown-menu > div {
    cursor: pointer;
  }

  .fixed-panel {
    position: fixed;
    bottom: 70px;
    right: 0;
    left: 90vw;
  }
`;

const ActionsButton = (props) => {
  const { loadingActions, handleDeleteSelected } = props;
  const [showActions, setShowActions] = useState(false);

  if (loadingActions) {
    return (
      <div className="btn-group ml-1">
        <Button classType="btn-light" text="Действия" disabled loading />
      </div>
    );
  }

  return (
    <ActionsButtonWrapper className={`btn-group dropup ml-1 ${showActions ? 'show' : ''}`}>
      <button
        type="button"
        className="btn btn-light dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        onClick={() => setShowActions(!showActions)}
      >
        Действия
        <i className="mdi mdi-chevron-up" />
      </button>
      <div
        className={`dropdown-menu ${showActions ? 'show' : ''}`}
        x-placement="bottom-start"
        onClick={() => setShowActions(false)}
      >
        <div className="dropdown-item" onClick={handleDeleteSelected} style={{ color: '#f1556c' }}>
          <i className="fe-trash-2" /> Отмена
        </div>
      </div>
    </ActionsButtonWrapper>
  );
};

const ReceiverBlock = (props) => {
  var receiver = props.row.delivery.receiver;

  var fullName = (
    (receiver.surname ? receiver.surname + ' ' : '') +
    (receiver.name ? receiver.name + ' ' : '') +
    (receiver.patronymic ? receiver.patronymic : '')
  ).trim();

  var template;

  var comment = '';

  if (props.row.comment) {
    comment = (
      <span className="hover-tooltip-wrapper">
        <i className="fe-message-circle" />
        <span className="hover-tooltip">{props.row.comment}</span>
      </span>
    );
  }

  // If customer is a company, change view
  if (props.row.legalEntity.type.toUpperCase() == 'PERSON') {
    template = (
      <div className="d-flex flex-column name">
        <div>
          {fullName}&nbsp;&nbsp;{comment}
        </div>
        <div>
          <small className="text-muted">{formatPhone(receiver.phone)}</small>
        </div>
      </div>
    );
  } else {
    template = (
      <div className="d-flex flex-column">
        <div>
          <a href="#">{props.row.legalEntity.name}</a>&nbsp;&nbsp;{comment}
        </div>
        <div>
          <small className="text-muted">{formatPhone(receiver.phone)}</small>
        </div>
      </div>
    );
  }

  return template;
};

function PaymentInfoBlock({ row }) {
  const { style, title } = getPaymentBagdeStyle(row);

  return (
    <span className="badge" style={style}>
      {title}
    </span>
  );
}

function LocationBlock(props) {
  var r1 = '',
    r2 = '';

  if (props.row.delivery.address.settlement && props.row.delivery.address.city) {
    //Если region = city = Москва, city = "" - обнуляем
    if (
      props.row.delivery.address.region &&
      props.row.delivery.address.region === props.row.delivery.address.city &&
      props.row.delivery.address.region.toUpperCase() === 'МОСКВА'
    ) {
      props.row.delivery.address.city = null;

      r1 = props.row.delivery.address.settlement;
    } else {
      r1 = props.row.delivery.address.settlement + ' (' + props.row.delivery.address.city + ')';
    }
  } else if (props.row.delivery.address.settlement && !props.row.delivery.address.city) {
    r1 = props.row.delivery.address.settlement;
  } else {
    r1 = props.row.delivery.address.city;

    //Если region = city = Москва, city = "" - обнуляем
    if (
      props.row.delivery.address.region &&
      props.row.delivery.address.region === props.row.delivery.address.city &&
      (props.row.delivery.address.region.toUpperCase() === 'МОСКВА' ||
        props.row.delivery.address.region.toUpperCase() === 'САНКТ-ПЕТЕРБУРГ')
    ) {
      props.row.delivery.address.region = null;
    }
  }

  if (props.row.delivery.address.region && props.row.delivery.address.area) {
    r2 = props.row.delivery.address.area + ' (' + props.row.delivery.address.region + ')';
  } else {
    r2 = props.row.delivery.address.region;
  }

  return (
    <div className="d-flex flex-column">
      <div>{r1}</div>
      <div>
        <small className="text-muted">{r2}</small>
      </div>
    </div>
  );
}

const THEAD_ITEMS = [
  'Заказ',
  'Покупатель',
  'Статус',
  'Служба доставки',
  'Населенный пункт',
  'Оплата',
  'Сумма',
];

const getTabOrdersLength = (tab, statusesLength) => {
  return tab.states.reduce((a, c) => {
    if (statusesLength[c]) {
      a += statusesLength[c];
    }
    return a;
  }, 0);
};

const getSearchStr = (search, page, filters, activeTab) => {
  let result = '?';
  if (search) {
    result += `search=${search}&`;
  }
  if (page) {
    result += `page=${page}&`;
  }
  if (activeTab) {
    result += `active_tab=${activeTab}&`;
  }

  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (value) {
      result += `urlfilter_${key}=${value}&`;
    }
  });

  return result.slice(0, -1);
};

const parseSearchStr = (str) => {
  const resultObj = qs.parse(str.slice(1));
  const filters = {};

  Object.keys(resultObj).forEach((key) => {
    if (key.indexOf('urlfilter_') !== -1) {
      filters[key.split('urlfilter_')[1]] = resultObj[key];
    }
  });

  return {
    activeTab: ORDERS_PAGE_TABS.find((t) => t.id === resultObj.active_tab) || ORDERS_PAGE_TABS[0],
    scroll: resultObj.scroll,
    reducerData: {
      search: resultObj.search || '',
      page: resultObj.page || 0,
      filters,
    },
  };
};

const getFilterFormInitial = (filters, deliveryInfo) => {
  if (
    !filters.date_from &&
    !filters.date_to &&
    !filters.delivery_code &&
    !filters.city &&
    !filters.product_id &&
    !filters.filter_states &&
    !filters.filter_phone &&
    !filters.filter_tracking_number &&
    !filters.filter_promocode
  ) {
    return null;
  }

  const initialObj = {
    dateFrom: filters.date_from ? new Date(filters.date_from) : null,
    dateTo: filters.date_to ? new Date(filters.date_to) : null,
    delivery: { label: 'Не выбрана' },
    status: null,
    city: filters.city ? filters.city : '',
    product: filters.product_id ? filters.product_id : '',
    phone: filters.filter_phone ? filters.filter_phone : '',
    trackingNumber: filters.filter_tracking_number ? filters.filter_tracking_number : '',
    promocode: filters.filter_promocode ? filters.filter_promocode : '',
  };
  if (filters.delivery_code) {
    const currentDelivery = deliveryInfo.find((d) => d.code === filters.delivery_code);
    if (currentDelivery) {
      initialObj.delivery = {
        value: currentDelivery.code,
        label:
          (currentDelivery.courierTitle ? currentDelivery.courierTitle : ``) +
          (currentDelivery.product ? `: ${currentDelivery.product}` : ``),
      };
    }
  }
  if (filters.filter_states) {
    initialObj.status = filters.filter_states
      .split(',')
      .map((s) => statusOptions.find((o) => o.value === s));
  }
  return initialObj;
};

const getInitialState = (props) => {
  return {
    initialized: false,
    search: null,
    page: 0,
    orders: [],
    totalItems: 0,
    filters: {},
  };
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'setInitialize':
      return { ...state, initialized: true };
    case 'setSearch':
      return { ...state, search: action.search, page: 0 };
    case 'setPage':
      return { ...state, page: action.page };
    case 'setOrders':
      return { ...state, orders: action.orders };
    case 'setTotalItems':
      return { ...state, totalItems: action.totalItems };
    case 'setFilters':
      return { ...state, filters: action.filters, page: 0 };
    case 'setStateFromUrlSearch':
      return {
        ...state,
        filters: action.data.filters,
        page: action.data.page,
        search: action.data.search,
        initialized: true,
      };
    default:
      return state;
  }
};

const SubscriptionsPage = (props) => {
  const { history, setMobileCustomMenu } = props;

  const reduxDispatch = useReduxDispatch();
  const [state, dispatch] = useReducer(reducer, getInitialState(props));
  const { checkoutSettings } = useSelector((state) => state.settings);
  const { tags } = useSelector((state) => state.orders);

  const [loading, setLoading] = useState(false);
  const [statusesLoading, setStatusesLoading] = useState(true);
  const [statusesLength, setStatusesLength] = useState({});
  const [selected, setSelected] = useState({});
  const [selectedAll, setSelectedAll] = useState(false);
  const [activeTab, setActiveTab] = useState('all');
  const [unpackingFilter, setUnpackingFilter] = useState(false);
  const [packingControlFilter, setPackingControlFilter] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [urlSearchStr, setUrlSearchStr] = useState(null);

  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [loadingPackaging, setLoadingPackaging] = useState(false);
  const [loadingReport, setLoadingReport] = useState(false);
  const [loadingCopy, setLoadingCopy] = useState(false);
  const [loadingActions, setLoadingActions] = useState(false);

  const warehouses = useSelector((state) =>
    state.orders.warehouses.map((w) => ({ label: w.title, value: w.code, data: w })),
  );
  const { deliveryInfo } = useSelector((state) => state.orders);
  const [activeWarehouse, setActiveWarehouse] = useState(warehouses.find((w) => w.data.isDefault));

  const [filterFormInitial, setFilterFormInitial] = useState(null);

  const [defaultScrollPosition, setDefaultScrollPosition] = useState(0);
  const [scrollPosition, setScrollPosition] = useState([]);

  const { initialized, search, page, orders, totalItems, filters } = state;

  useEffect(() => {
    window.addEventListener('scroll', onMouseUpdate, false);
    function onMouseUpdate() {
      setScrollPosition(window.scrollY);
    }

    if (history.location.search) {
      const stateFromUrlSearch = parseSearchStr(history.location.search);
      setDefaultScrollPosition(stateFromUrlSearch.scroll);
      dispatch({ type: 'setStateFromUrlSearch', data: stateFromUrlSearch.reducerData });
      setActiveTab(stateFromUrlSearch.activeTab.id);
      if (Object.keys(stateFromUrlSearch.reducerData.filters).length) {
        const filterFormInitial = getFilterFormInitial(
          stateFromUrlSearch.reducerData.filters,
          deliveryInfo,
        );
        if (filterFormInitial) {
          setFilterFormInitial(filterFormInitial);
          setShowFilter(true);
        } else {
          const buttonFilter = stateFromUrlSearch.reducerData.filters.button_filter;
          if (buttonFilter === 'unpackingFilter') {
            setUnpackingFilter(true);
          }
          if (buttonFilter === 'controlPackingFilter') {
            setPackingControlFilter(true);
          }
        }
      }
    }

    (async function () {
      await updateStatuses();
    })();

    return () => {
      window.removeEventListener('scroll', onMouseUpdate, false);
    };
  }, []);

  const updateStatuses = async () => {
    const newStatusesLength = await reduxDispatch(fetchGetOrdersStatusesLength());
    setStatusesLength(newStatusesLength);
    setStatusesLoading(false);
  };

  const updateOrders = async () => {
    const result = await handleGetOrders();
    dispatch({ type: 'setOrders', orders: result.orders });
    dispatch({ type: 'setTotalItems', totalItems: result.recordsTotal });
    dispatch({ type: 'setInitialize' });
  };

  useEffect(() => {
    if (history.location.search ? initialized : true) {
      (async function () {
        updateOrders().then();
        const newUrlSearchStr = getSearchStr(search, page, filters, activeTab);
        setUrlSearchStr(newUrlSearchStr);
      })();
    }
  }, [search, page, filters, activeTab]);

  useEffect(() => {
    history.push({
      search: urlSearchStr,
    });
  }, [urlSearchStr]);

  useEffect(() => {
    if (defaultScrollPosition && orders.length) {
      window.scroll(0, defaultScrollPosition);
      setScrollPosition(0);
      setDefaultScrollPosition(0);
    }
  }, [defaultScrollPosition, orders]);

  useEffect(() => {
    if (!tags) reduxDispatch(fetchTags());
  }, [reduxDispatch, tags]);

  const handleGetOrders = async () => {
    let sendObj = Object.assign(
      {},
      {
        size: ORDERS_COUNT_ON_PAGE,
        order_types: 'KAK2C_SUBSCRIPTION',
      },
      { search },
      filters,
      { activeTab },
    );

    if (typeof page !== 'undefined') sendObj.page = page;

    if (history.location.state) {
      if (history.location.state.reservedVariantId) {
        sendObj['reserved_variant_id'] = history.location.state.reservedVariantId;
      }
      if (history.location.state.warehouseCode) {
        sendObj['warehouse_code'] = history.location.state.warehouseCode;
      }
    }

    setLoading(true);

    return await reduxDispatch(fetchGetOrdersForOrdersPage(sendObj)).finally(() => {
      setLoading(false);
    });
  };

  const handleToggleMainCheckbox = () => {
    const newSelected = selectedAll
      ? {}
      : orders.reduce((a, c) => {
          a[c.id] = true;
          return a;
        }, {});
    setSelectedAll(!selectedAll);
    setSelected(newSelected);
  };

  const handleToggleCheckbox = (itemId) => {
    const currentState = selected[itemId];
    const newSelected = Object.assign({}, selected, { [itemId]: !currentState });
    setSelectedAll(false);
    setSelected(newSelected);
  };

  const handleSearch = (value) => {
    dispatch({ type: 'setSearch', search: value });
  };

  const handlePageSelect = (pageIndex) => {
    dispatch({ type: 'setPage', page: pageIndex });
    clearSelected();
    setUnpackingFilter(false);
  };

  const clearSelected = () => {
    setSelectedAll(false);
    setSelected({});
    setPackingControlFilter(false);
    setUnpackingFilter(false);
  };

  const handleNewOrder = () => {
    history.push('orders/new');
  };

  const handleCloseFilter = () => {
    setShowFilter(false);
    dispatch({ type: 'setFilters', filters: {} });
  };

  const handleSetFilters = (filters) => {
    if (filters.filter_states) {
      setActiveTab('all');
    }
    dispatch({ type: 'setFilters', filters });
  };

  const handleSetUnpackingFilter = () => {
    clearSelected();
    setUnpackingFilter(!unpackingFilter);
    if (!unpackingFilter) {
      dispatch({ type: 'setFilters', filters: { button_filter: 'unpackingFilter' } });
    } else {
      dispatch({ type: 'setFilters', filters: {} });
    }
  };

  const handleSetControlPacking = () => {
    clearSelected();
    setPackingControlFilter(!packingControlFilter);
    if (!packingControlFilter) {
      dispatch({ type: 'setFilters', filters: { button_filter: 'controlPackingFilter' } });
    } else {
      dispatch({ type: 'setFilters', filters: {} });
    }
  };

  const handleOpenTab = (tab) => {
    clearSelected();
    setUnpackingFilter(false);
    dispatch({ type: 'setPage', page: 0 });
    setActiveTab(tab.id);
    dispatch({ type: 'setSearch', search: `` });
    let newFilters = { ...filters, problemOrders: false };
    if (tab.problems) {
      newFilters = { ...newFilters, problemOrders: true };
    }
    dispatch({ type: 'setFilters', filters: newFilters });
  };

  const handleCopySelected = async () => {
    const copyOrders = Object.assign({}, selected);
    setLoadingCopy(true);
    clearSelected();
    for (let orderId in copyOrders) {
      if (copyOrders[orderId]) {
        await reduxDispatch(fetchCopyOrder(orderId))
          .then(() => {
            toast.info(`Заказ ${orderId} успешно скопирован`);
            Promise.all([updateStatuses(), updateOrders()]);
          })
          .catch((error) => {
            error.data.errors.forEach((e) => {
              toast.error(e.message);
            });
          });
      }
    }
    setLoadingCopy(false);
  };

  const handleConfirmSelected = async () => {
    const confirmOrders = Object.assign({}, selected);
    clearSelected();
    setLoadingConfirm(true);
    for (let orderId in confirmOrders) {
      if (confirmOrders[orderId]) {
        await reduxDispatch(fetchConfirmOrder({ id: orderId, confirmStatus: 'APPROVED' }))
          .then(() => {
            toast.info(`Заказ ${orderId} успешно подтвержден`);
            Promise.all([updateStatuses(), updateOrders()]);
          })
          .catch((error) => {
            error.data.errors.forEach((e) => {
              toast.error(e.message);
            });
          });
      }
    }
    setLoadingConfirm(false);
  };

  const handlePackagingSelected = async () => {
    setLoadingPackaging(true);
    const packagingOrders = Object.keys(selected)
      .filter((key) => selected[key])
      .map((key) => key);
    const result = await reduxDispatch(
      fetchUpdatePackingBatch({ orders: packagingOrders }),
    ).finally(() => {
      clearSelected();
      setLoadingPackaging(false);
      dispatch({ type: 'setFilters', filters: { ...filters, button_filter: null } });
    });
    if (result) {
      const handleDowloadDoc = () => {
        saveBase64AsPdf({
          content: result.content,
          fileName: `Стикеры-${moment().format('DD-MM-YYYY-HH:mm:SS')}.pdf`,
        });
      };
      const canDownloadDoc = result.content && result.orders.find((o) => o.success);
      if (canDownloadDoc) {
        handleDowloadDoc();
      }

      let successCount = 0;
      const errorsArr = [];
      result.orders.forEach((o) => {
        if (o.success) {
          successCount += 1;
        } else {
          errorsArr.push({
            id: o.id,
            errorMessage: o.errors[0].message,
          });
        }
      });

      reduxDispatch(
        showModal('PackingBatchResult', {
          canDownloadDoc,
          successCount,
          errorsArr,
          handleDowloadDoc,
        }),
      );

      Promise.all([updateStatuses(), updateOrders()]);
    }
  };

  const handleShippingOrders = (shippingOrders) => {
    reduxDispatch(
      showModal('ShippingOrders', {
        isNew: true,
        shouldFindClosest: true,
        addAllExistOrders: !shippingOrders.length,
        shippingOrders,
        warehouse: activeWarehouse.data,
      }),
    );
  };

  const handleGetReport = async () => {
    setLoadingReport(true);
    const report = await reduxDispatch(fetchGetOrdersReport());
    saveBase64AsPdf(report);
    setLoadingReport(false);
  };

  const handleAddTag = (e, order) => {
    e.stopPropagation();
    reduxDispatch(
      showModal('ChooseTags', { orderId: order.id, orderTags: order.tags, update: updateOrders }),
    );
  };

  const handleDeleteSelected = () => {
    reduxDispatch(
      showModal('ClarifyModal', {
        submitCallback: async () => {
          setLoadingActions(true);
          for (let orderId in selected) {
            await reduxDispatch(
              fetchCancelOrder({
                orderId,
              }),
            ).then(() => {
              toast.info(`Заказ ${orderId} успешно отменен`);
            });
          }
          clearSelected();
          await updateOrders();
          setLoadingActions(false);
        },
        actionName: 'Отменить',
        content: <p>Вы действительно хотите отменить выбранные заказы?</p>,
      }),
    );
  };

  if (!initialized) return null;

  const selectedLength = Object.values(selected).filter((v) => v).length;

  const showFixedPanelAgreement =
    activeTab === 'agreement' && (selectedLength > 0 || loadingConfirm);
  const showFixedPanelEquipment =
    activeTab === 'equipment' &&
    (selectedLength > 0 || loadingPackaging) &&
    activeWarehouse.data.operatorType === 'MANUAL';

  const unpackingOrders =
    activeTab === 'equipment' && orders.filter((o) => o.status === 'ORDER_INFO_READY_TO_PACK');
  const packingControlOrders =
    activeTab === 'equipment' && orders.filter((o) => o.status === 'ORDER_INFO_IN_PACKING');

  const filteredOrders = orders;

  const currencySymbol = getCurrencySymbol(checkoutSettings.currency);

  const adaptiveProps = {
    selectedLength,
    clearSelected: isMobile().any ? undefined : clearSelected,
    loadingCopy: isMobile().any ? undefined : loadingCopy,
    handleCopySelected: isMobile().any ? undefined : handleCopySelected,
    ActionsButton: isMobile().any ? undefined : ActionsButton,
    loadingActions: isMobile().any ? undefined : loadingActions,
    handleDeleteSelected: isMobile().any ? undefined : handleDeleteSelected,
    showFixedPanelAgreement: isMobile().any ? undefined : showFixedPanelAgreement,
    loadingConfirm: isMobile().any ? undefined : loadingConfirm,
    handleConfirmSelected: isMobile().any ? undefined : handleConfirmSelected,
    showFixedPanelEquipment: isMobile().any ? undefined : showFixedPanelEquipment,
    loadingPackaging: isMobile().any ? undefined : loadingPackaging,
    handlePackagingSelected: isMobile().any ? undefined : handlePackagingSelected,
    activeTab,
    handleOpenTab,
    statusesLoading,
    getTabOrdersLength,
    statusesLength,
    orders,
    search,
    selected,
    showFilter,
    unpackingOrders,
    unpackingFilter,
    packingControlOrders,
    packingControlFilter,
    loadingReport,
    warehouses,
    activeWarehouse,
    setActiveWarehouse,
    handleSearch,
    setShowFilter,
    handleCloseFilter,
    handleSetFilters,
    handleSetUnpackingFilter,
    handleSetControlPacking,
    handleShippingOrders,
    handleNewOrder,
    handleGetReport,
    updateOrders,
    updateStatuses,
    history,
    filterFormInitial,
    setFilterFormInitial,
    loading,
    filters,
    handleToggleMainCheckbox: isMobile().any ? undefined : handleToggleMainCheckbox,
    selectedAll: isMobile().any ? undefined : selectedAll,
    THEAD_ITEMS: isMobile().any ? undefined : THEAD_ITEMS,
    filteredOrders,
    handleToggleCheckbox: isMobile().any ? undefined : handleToggleCheckbox,
    urlSearchStr,
    scrollPosition,
    handleAddTag: isMobile().any ? undefined : handleAddTag,
    ReceiverBlock,
    LocationBlock: isMobile().any ? undefined : LocationBlock,
    PaymentInfoBlock,
    currencySymbol,
    totalItems,
    page,
    handlePageSelect,
    setMobileCustomMenu,
  };

  return (
    <Adaptive
      DekstopComponent={DesktopLayout}
      MobileComponent={MobileLayout}
      adaptiveProps={adaptiveProps}
    />
  );
};

export default SubscriptionsPage;
